

import { classesRuntime, statesRuntime } from "./../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_109_2_spacing";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_109_2_spacing__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"spacing01":"1px","spacing02":"2px","spacing03":"3px","spacing06":"6px","spacing12":"12px","spacing18":"18px","spacing24":"24px","spacing30":"30px","spacing36":"36px","spacing42":"42px","spacing48":"48px","spacing78":"78px","spacing90":"90px","Spacing":"6px","SP1":"calc(6px * 1)","SP2":"calc(6px * 2)","SP3":"calc(6px * 3)","SP4":"calc(6px * 4)","SP5":"calc(6px * 5)","SP6":"calc(6px * 6)","SP7":"calc(6px * 7)","SP8":"calc(6px * 8)","SP9":"calc(6px * 9)","SP10":"calc(6px * 10)"}; 
export var vars = {}; 




